import { useState } from "react";
import CAPEVRParent from "../../../../activities/cape-vr/CAPEVRParent";
import { resolveSinglePrimaryTrial } from "../../assignmentTrial";
import PresentedStimulusAudio from "../../components/PresentedStimulusAudio";
import { useOptionalTaskRuntime } from "../../context/TaskRuntimeContext";
import CitationsPanel from "../../../../components/citations/CitationsPanel";

export default function CapeVrAssignmentTask({ task, session, onResponse }) {
  const runtime = useOptionalTaskRuntime();
  task = task || runtime?.task;
  session = session || runtime?.session;
  const [error, setError] = useState("");
  const trial = resolveSinglePrimaryTrial(session);
  const taskProvenance = task?.responseConfig?.sampleTaskProvenance;

  const submit = async normalized => {
    const payload = {
      sessionId: session?._id,
      trialId: trial.trialId || trial._id,
      stimulusInstanceId: trial.stimuli[0].stimulusInstanceId,
      responseType: "rating",
      response: {
        responseContract: normalized.responseContract,
        instrumentResponse: normalized.instrumentResponse,
      },
    };
    if (onResponse) return onResponse(payload);
    const result = await fetch(`${runtime.apiUrl}/evaluation/response`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${runtime.token}` },
      body: JSON.stringify(payload),
    });
    if (!result.ok) {
      setError("The CAPE-Vr response could not be saved.");
      return;
    }
    await runtime?.completeCurrentStep?.(session._id);
  };

  const stimulus = trial?.stimuli?.find(item => item.role === "primary") || trial?.stimuli?.[0] || {};
  const projectedSample = stimulus.presentation?.selectedSample;
  const selectedSample = projectedSample
    ? { ...projectedSample, sampleLink: stimulus.sampleLink || null }
    : {
      _id: stimulus.voiceSampleId || stimulus.stimulusInstanceId,
      sampleLink: stimulus.sampleLink || null,
      identificationData: {},
      subjectId: null,
    };
  const references = stimulus.presentation?.references || {};

  return <section aria-label="CAPE-Vr evaluation">
    <CAPEVRParent
      selectedSample={selectedSample}
      useCase="evaluation"
      sampleTaskProvenance={taskProvenance}
      renderSample={() => <PresentedStimulusAudio trial={trial} />}
      onAssessmentSubmit={submit}
    />
    <CitationsPanel
      toolName="CAPE-Vr"
      voiceDatabase={references.voiceDatabase || null}
      voiceCollection={references.voiceCollection || null}
      representationTransformations={references.representationTransformations || []}
    />
    {error ? <p role="alert">{error}</p> : null}
  </section>;
}
